import { Injectable } from '@angular/core';
import { ScriptExternoService } from '../../script-externo.service';

@Injectable()
export class MathtagService {

  scripts: Array<string> = []; 

  constructor(private script: ScriptExternoService) { }

  gerarScript(src: string): string {
    return this.script.gerarScript({ src });
  }   
  
  inscricaoCurso(mt_id=undefined) {    
    //let ids = this.getId(id); 
    this.scripts.push(
      this.gerarScript('//pixel.mathtag.com/event/js?mt_id=1348903&mt_adid=214264&mt_exem=&mt_excl=&v1=&v'),
    );
  }

  inscricaoDadosPessoais(mt_id=undefined) {
    //let ids = this.getId(id); 
    this.scripts.push(
      this.gerarScript('//pixel.mathtag.com/event/js?mt_id=1348904&mt_adid=214264&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3='),
    );
  }
   
  inscricaoAgendamento(mt_id = undefined) {
    this.scripts.push(
      this.gerarScript(`//pixel.mathtag.com/event/js?mt_id=${mt_id}&mt_adid=214264&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`),
    );
  }

  inscricaoPagamento(mt_id=undefined) {
    //let ids = this.getId(id); 
    this.scripts.push(
      this.gerarScript('//pixel.mathtag.com/event/js?mt_id=1348907&mt_adid=214264&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3='),
    );
  }

  inscricaoFinalizacao(mt_id=undefined) {
    //let ids = this.getId(id); 
    this.scripts.push(
      this.gerarScript('//pixel.mathtag.com/event/js?mt_id=1348892&mt_adid=214264&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3='),
    );
  }

  removerTodosScripts() {
    this.scripts.forEach(id => this.removerScript(id));
  }

  removerScript(id: string): void {
    this.script.removerScript(id);
  }
}


